(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gv-bestseller"] && !Shopify.designMode) return;
  try {
    
(function(){
  function gvpData(card){
    if(!card._v){ var ve=card.querySelector('[data-gvp-variants]'), se=card.querySelector('[data-gvp-selected]');
      card._v = ve ? JSON.parse(ve.textContent) : []; card._sel = se ? JSON.parse(se.textContent) : []; }
    return card._v;
  }
  function gvpUpdate(card){
    var vs=gvpData(card), sel=card._sel;
    card.querySelectorAll('[data-opt]').forEach(function(b){ var i=+b.getAttribute('data-opt'); b.classList.toggle('is-on', b.getAttribute('data-val')===sel[i]); });
    var v=null; for(var i=0;i<vs.length;i++){ var ok=true; for(var j=0;j<sel.length;j++){ if(vs[i].options[j]!==sel[j]){ok=false;break;} } if(ok){v=vs[i];break;} }
    if(!v) return;
    var img=card.querySelector('[data-gvp-main]'), price=card.querySelector('[data-gvp-price]'), vid=card.querySelector('[data-gvp-vid]'), btn=card.querySelector('.gvp-qa');
    if(vid) vid.value=v.id;
    if(img && v.img) img.src=v.img;
    if(price) price.innerHTML=(v.onsale?'<span class="gvp-was">'+v.cprice+'</span>':'')+v.price;
    if(btn && btn.tagName==='BUTTON'){ if(v.available){ btn.disabled=false; btn.textContent='+ In den Warenkorb'; } else { btn.disabled=true; btn.textContent='Ausverkauft'; } }
    card.classList.toggle('is-soldout', !v.available);
  }
  document.addEventListener('click', function(e){
    var b=e.target.closest('[data-opt]'); if(!b) return;
    var card=b.closest('[data-gvp]'); if(!card) return;
    gvpData(card); card._sel[+b.getAttribute('data-opt')]=b.getAttribute('data-val'); gvpUpdate(card);
  });
  function wish(){ try{ return JSON.parse(localStorage.getItem('gv_wish')||'[]'); }catch(e){ return []; } }
  function saveWish(a){ try{ localStorage.setItem('gv_wish', JSON.stringify(a)); }catch(e){} }
  function paintWish(){ var w=wish(); document.querySelectorAll('[data-gvp-wish]').forEach(function(b){ var on=w.indexOf(b.getAttribute('data-gvp-wish'))>=0; b.classList.toggle('is-on',on); b.setAttribute('aria-pressed',on?'true':'false'); }); }
  document.addEventListener('click', function(e){ var btn=e.target.closest('[data-gvp-wish]'); if(!btn) return; e.preventDefault(); var id=btn.getAttribute('data-gvp-wish'),w=wish(),i=w.indexOf(id); if(i>=0){w.splice(i,1);}else{w.push(id);} saveWish(w); paintWish(); });
  paintWish();
  // Warenkorb: NATIVER Formular-Submit -> Theme-Warenkorb (lädt /cart-Seite). Kein AJAX/Drawer;
  // der Warenkorb wird komplett vom Theme verwaltet. Die Karten-Picker halten [data-gvp-vid] aktuell.
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gv-collection"] && !Shopify.designMode) return;
  try {
    
(function(){
  // ---- Varianten-Picker je Karte: Farbe/Größe -> Bild + Preis + Warenkorb-Variante + Verfügbarkeit
  function gvpData(card){
    if(!card._v){ var ve=card.querySelector('[data-gvp-variants]'), se=card.querySelector('[data-gvp-selected]');
      card._v = ve ? JSON.parse(ve.textContent) : []; card._sel = se ? JSON.parse(se.textContent) : []; }
    return card._v;
  }
  function gvpUpdate(card){
    var vs=gvpData(card), sel=card._sel;
    card.querySelectorAll('[data-opt]').forEach(function(b){ var i=+b.getAttribute('data-opt'); b.classList.toggle('is-on', b.getAttribute('data-val')===sel[i]); });
    var v=null; for(var i=0;i<vs.length;i++){ var ok=true; for(var j=0;j<sel.length;j++){ if(vs[i].options[j]!==sel[j]){ok=false;break;} } if(ok){v=vs[i];break;} }
    if(!v) return;
    var img=card.querySelector('[data-gvp-main]'), price=card.querySelector('[data-gvp-price]'), vid=card.querySelector('[data-gvp-vid]'), btn=card.querySelector('.gvp-qa');
    if(vid) vid.value=v.id;
    if(img && v.img) img.src=v.img;
    if(price) price.innerHTML=(v.onsale?'<span class="gvp-was">'+v.cprice+'</span>':'')+v.price;
    if(btn && btn.tagName==='BUTTON'){ if(v.available){ btn.disabled=false; btn.textContent='+ In den Warenkorb'; } else { btn.disabled=true; btn.textContent='Ausverkauft'; } }
    card.classList.toggle('is-soldout', !v.available);
  }
  document.addEventListener('click', function(e){
    var b=e.target.closest('[data-opt]'); if(!b) return;
    var card=b.closest('[data-gvp]'); if(!card) return;
    gvpData(card); card._sel[+b.getAttribute('data-opt')]=b.getAttribute('data-val'); gvpUpdate(card);
  });

  // ---- Merkliste (localStorage), seitenübergreifend
  function wish(){ try{ return JSON.parse(localStorage.getItem('gv_wish')||'[]'); }catch(e){ return []; } }
  function saveWish(a){ try{ localStorage.setItem('gv_wish', JSON.stringify(a)); }catch(e){} }
  function paintWish(){
    var w = wish();
    document.querySelectorAll('[data-gvp-wish]').forEach(function(b){
      var on = w.indexOf(b.getAttribute('data-gvp-wish'))>=0;
      b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on?'true':'false');
    });
  }
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-gvp-wish]'); if(!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-gvp-wish'), w = wish(), i = w.indexOf(id);
    if(i>=0){ w.splice(i,1); } else { w.push(id); }
    saveWish(w); paintWish();
  });
  paintWish();

  // ---- Quick-Add: NATIVER Formular-Submit -> Theme-Warenkorb (lädt /cart-Seite).
  // Kein AJAX/Drawer; der Warenkorb wird komplett vom Theme verwaltet. Die Karten-
  // Picker (Farbe/Größe) halten das versteckte [data-gvp-vid]-Feld aktuell, sodass die
  // gewählte Variante nativ gepostet wird.

  // ---- Filter auto-submit + Mobil-Toggle
  // Filter/Sort-Inputs sind per form="gvcForm" verknüpft (NICHT im Form verschachtelt, damit die
  // Karten-Warenkorb-Formulare nativ funktionieren) -> Change am Layout-Container abfangen.
  var form = document.getElementById('gvcForm');
  var flayout = document.querySelector('.gvc-layout');
  if(form && flayout){ flayout.addEventListener('change', function(e){
    if(e.target.matches('input[type=checkbox], select')){ if(form.requestSubmit){ form.requestSubmit(); } else { form.submit(); } }
  }); }
  document.addEventListener('click', function(e){
    var t = e.target.closest('.gvc-filtoggle'); if(!t) return;
    var f = document.getElementById('gvcFilters'); if(!f) return;
    var open = f.classList.toggle('is-open'); t.setAttribute('aria-expanded', open?'true':'false');
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gv-header"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initHeader(root){
    if(root.dataset.gvhInit) return; root.dataset.gvhInit='1';
    function open(){ root.classList.add('is-open'); var b=root.querySelector('[data-gvh-open]'); if(b)b.setAttribute('aria-expanded','true'); document.documentElement.style.overflow='hidden'; }
    function close(){ root.classList.remove('is-open'); var b=root.querySelector('[data-gvh-open]'); if(b)b.setAttribute('aria-expanded','false'); document.documentElement.style.overflow=''; }
    var ob=root.querySelector('[data-gvh-open]'); if(ob) ob.addEventListener('click', open);
    root.querySelectorAll('[data-gvh-close]').forEach(function(el){ el.addEventListener('click', close); });
    root.querySelectorAll('.gvh-dnav a').forEach(function(a){ a.addEventListener('click', close); });
    // Ausklappbare Suche
    var st=root.querySelector('[data-gvh-search]'), sb=root.querySelector('.gvh-searchbar');
    function sOpen(){ if(!sb)return; sb.hidden=false; if(st)st.setAttribute('aria-expanded','true'); var i=sb.querySelector('input'); if(i)setTimeout(function(){ i.focus(); },30); }
    function sClose(){ if(!sb)return; sb.hidden=true; if(st)st.setAttribute('aria-expanded','false'); }
    if(st&&sb) st.addEventListener('click', function(){ if(sb.hidden){ sOpen(); } else { sClose(); } });
    root.querySelectorAll('[data-gvh-search-close]').forEach(function(el){ el.addEventListener('click', sClose); });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape'){ close(); sClose(); } });
  }
  function initAll(){ document.querySelectorAll('.gvh').forEach(initHeader); }
  if(document.readyState!=='loading') initAll(); else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gv-product"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.querySelector('[data-gvpd]'); if(!root) return;
  var vEl = root.querySelector('[data-gvpd-variants]'), sEl = root.querySelector('[data-gvpd-selected]');
  var variants = vEl ? JSON.parse(vEl.textContent) : [];
  var selected = sEl ? JSON.parse(sEl.textContent) : [];
  var colorIdx = parseInt(root.getAttribute('data-color-idx'), 10);
  var LOWSTOCK = parseInt(root.getAttribute('data-lowstock'), 10); if(isNaN(LOWSTOCK)) LOWSTOCK=5;
  var idInput = root.querySelector('[data-gvpd-id]'), priceEl = root.querySelector('[data-gvpd-price]');
  var addBtn = root.querySelector('[data-gvpd-add]'), mainImg = root.querySelector('[data-gvpd-main]');
  var colorName = root.querySelector('[data-gvpd-colorname]');
  function findVariant(){ for(var i=0;i<variants.length;i++){ var v=variants[i],ok=true; for(var j=0;j<selected.length;j++){ if(v.options[j]!==selected[j]){ok=false;break;} } if(ok) return v; } return null; }
  function update(){
    root.querySelectorAll('[data-opt]').forEach(function(b){ var i=+b.getAttribute('data-opt'); b.classList.toggle('is-on', b.getAttribute('data-val')===selected[i]); });
    if(colorName && colorIdx>=0){ colorName.textContent = selected[colorIdx]; }
    var v = findVariant();
    if(!v){ if(addBtn){addBtn.disabled=true;addBtn.textContent='Nicht verfügbar';} return; }
    if(idInput) idInput.value = v.id;
    if(priceEl){ priceEl.innerHTML = (v.onsale ? '<span class="gvpd-was">'+v.cprice+'</span> ' : '') + v.price; }
    if(v.img && mainImg){ mainImg.src = v.img; root.querySelectorAll('.gvpd-thumb').forEach(function(t){t.classList.remove('is-on');}); }
    if(addBtn){ if(v.available){ addBtn.disabled=false; addBtn.textContent='In den Warenkorb'; } else { addBtn.disabled=true; addBtn.textContent='Ausverkauft'; } }
    var availEl = root.querySelector('[data-gvpd-avail]');
    if(availEl){
      if(!v.available){ availEl.className='gvpd-avail is-out'; availEl.textContent='Ausverkauft'; }
      else if(v.track && !v.cont && v.qty>0 && v.qty<=LOWSTOCK){ availEl.className='gvpd-avail is-low'; availEl.textContent='Nur noch '+v.qty+' verfügbar'; }
      else { availEl.className='gvpd-avail is-in'; availEl.textContent='Auf Lager'; }
    }
  }
  root.addEventListener('click', function(e){
    var b = e.target.closest('[data-opt]'); if(b){ selected[+b.getAttribute('data-opt')] = b.getAttribute('data-val'); update(); return; }
    var th = e.target.closest('[data-gvpd-thumb]'); if(th && mainImg){ mainImg.src = th.getAttribute('data-gvpd-thumb'); root.querySelectorAll('.gvpd-thumb').forEach(function(t){t.classList.remove('is-on');}); th.classList.add('is-on'); return; }
  });
  update();

  // Galerie-Zoom (Desktop) + Lightbox
  var lb = root.querySelector('[data-gvpd-lb]'), lbImg = root.querySelector('[data-gvpd-lb-img]'), mainBox = root.querySelector('[data-gvpd-mainbox]');
  if(mainBox && mainImg && window.matchMedia('(min-width:901px)').matches){
    mainBox.addEventListener('mousemove', function(e){ var r=mainBox.getBoundingClientRect(); mainImg.style.transformOrigin=((e.clientX-r.left)/r.width*100)+'% '+((e.clientY-r.top)/r.height*100)+'%'; });
    mainBox.addEventListener('mouseenter', function(){ mainBox.classList.add('is-zoom'); });
    mainBox.addEventListener('mouseleave', function(){ mainBox.classList.remove('is-zoom'); mainImg.style.transformOrigin='center'; });
  }
  if(mainBox && mainImg){ mainBox.addEventListener('click', function(){ if(lb && lbImg){ lbImg.src=mainImg.src; lb.hidden=false; } }); }
  if(lb){ lb.addEventListener('click', function(e){ if(e.target===lb || e.target.closest('[data-gvpd-lb-close]')){ lb.hidden=true; } }); }
  document.addEventListener('keydown', function(e){ if(e.key==='Escape'){ if(lb) lb.hidden=true; root.querySelectorAll('.gvpd-modal').forEach(function(m){ m.hidden=true; }); } });

  // Merkliste
  function wish(){ try{ return JSON.parse(localStorage.getItem('gv_wish')||'[]'); }catch(e){ return []; } }
  function paintWish(){ var w=wish(); root.querySelectorAll('[data-gvpd-wish]').forEach(function(b){ var on=w.indexOf(b.getAttribute('data-gvpd-wish'))>=0; b.classList.toggle('is-on',on); b.setAttribute('aria-pressed',on?'true':'false'); }); }
  root.addEventListener('click', function(e){ var btn=e.target.closest('[data-gvpd-wish]'); if(!btn) return; e.preventDefault(); var id=btn.getAttribute('data-gvpd-wish'),w=wish(),i=w.indexOf(id); if(i>=0){w.splice(i,1);}else{w.push(id);} try{localStorage.setItem('gv_wish',JSON.stringify(w));}catch(e2){} paintWish(); });
  paintWish();

  // Größentabelle-Modal
  var modal = root.querySelector('[data-gvpd-modal]');
  root.addEventListener('click', function(e){
    if(e.target.closest('[data-gvpd-sizechart]') && modal){ modal.hidden=false; }
    if(e.target.closest('[data-gvpd-modal-close]') && modal){ modal.hidden=true; }
  });

  // Größenberater
  var SIZEFIT={
    Damen:{chest:[['XS',82],['S',88],['M',94],['L',100],['XL',106],['XXL',112],['3XL',118]],
           waist:[['XS',68],['S',74],['M',80],['L',86],['XL',92],['XXL',98],['3XL',104]],
           hip:[['XS',92],['S',98],['M',104],['L',110],['XL',116],['XXL',122],['3XL',128]]},
    Herren:{chest:[['S',94],['M',100],['L',106],['XL',112],['XXL',118],['3XL',124]],
            waist:[['S',81],['M',87],['L',93],['XL',99],['XXL',105],['3XL',111]],
            hip:[['S',93],['M',99],['L',105],['XL',111],['XXL',117],['3XL',123]]}
  };
  function ffIndex(a,v){ for(var i=0;i<a.length;i++){ if(v<=a[i][1]) return i; } return a.length-1; }
  var ff = root.querySelector('[data-gvpd-ff]');
  function ffGender(){ return ff && ff.getAttribute('data-gender')==='Damen' ? 'Damen' : 'Herren'; }
  function ffPaint(){ if(!ff) return; var g=ffGender(); ff.querySelectorAll('[data-ff-g]').forEach(function(b){ b.classList.toggle('is-on', b.getAttribute('data-ff-g')===g); }); }
  if(ff){ ffPaint();
    root.addEventListener('click', function(e){
      if(e.target.closest('[data-gvpd-fitfinder]')){ ff.hidden=false; ffPaint(); }
      if(e.target.closest('[data-gvpd-ff-close]')){ ff.hidden=true; }
      var gb=e.target.closest('[data-ff-g]'); if(gb){ ff.setAttribute('data-gender', gb.getAttribute('data-ff-g')); ffPaint(); }
      if(e.target.closest('[data-gvpd-ff-go]')){
        var c=SIZEFIT[ffGender()], idx=[];
        var ch=+ff.querySelector('[data-ff="chest"]').value, wa=+ff.querySelector('[data-ff="waist"]').value, hp=+ff.querySelector('[data-ff="hip"]').value;
        if(ch>0) idx.push(ffIndex(c.chest,ch));
        if(wa>0) idx.push(ffIndex(c.waist,wa));
        if(hp>0) idx.push(ffIndex(c.hip,hp));
        var res=ff.querySelector('[data-gvpd-ff-result]');
        if(!idx.length){ res.innerHTML='<div class="gvpd-ff-hint">Bitte mindestens den Brustumfang eingeben.</div>'; return; }
        var mx=Math.max.apply(null,idx), label=c.chest[Math.min(mx,c.chest.length-1)][0];
        var spread=idx.length>1 && Math.max.apply(null,idx)!==Math.min.apply(null,idx);
        res.innerHTML='<div class="gvpd-ff-rec">Empfohlene Größe: <b>'+label+'</b></div>'+(spread?'<div class="gvpd-ff-note">Deine Maße liegen zwischen Größen – wir empfehlen die größere für mehr Komfort.</div>':'');
        var sb=root.querySelector('.gvpd-size[data-val="'+label+'"]'); if(sb){ sb.click(); res.innerHTML+='<div class="gvpd-ff-note">Größe '+label+' wurde für dich ausgewählt.</div>'; }
      }
    });
  }

  // Warenkorb: NATIVER Formular-Submit -> Theme-Warenkorb (lädt /cart-Seite).
  // Kein AJAX, kein eigener Drawer – der Warenkorb wird komplett vom Theme verwaltet.
  // Der Varianten-Picker hält das versteckte [data-gvpd-id]-Feld aktuell, daher wird
  // beim Klick auf „In den Warenkorb" die gewählte Variante nativ gepostet.
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gv-related"] && !Shopify.designMode) return;
  try {
    
(function(){
  function wish(){ try{ return JSON.parse(localStorage.getItem('gv_wish')||'[]'); }catch(e){ return []; } }
  function paintWish(){ document.querySelectorAll('[data-gvrel-wish]').forEach(function(b){ var on=wish().indexOf(b.getAttribute('data-gvrel-wish'))>=0; b.classList.toggle('is-on',on); b.setAttribute('aria-pressed',on?'true':'false'); }); }
  document.addEventListener('click', function(e){
    var btn=e.target.closest('[data-gvrel-wish]'); if(!btn) return; e.preventDefault();
    var id=btn.getAttribute('data-gvrel-wish'),w=wish(),i=w.indexOf(id); if(i>=0){w.splice(i,1);}else{w.push(id);} try{localStorage.setItem('gv_wish',JSON.stringify(w));}catch(e2){} paintWish();
  });
  // Warenkorb: NATIVER Formular-Submit -> Theme-Warenkorb (lädt /cart-Seite). Kein AJAX/Drawer;
  // funktioniert auch für die per Recommendations-API nachgeladenen Karten (action=cart_add_url).
  // Empfehlungen nachladen (Shopify Recommendations API)
  var el=document.querySelector('[data-gvrel]'); if(!el) return;
  if(el.querySelector('.gvp-card')){ paintWish(); return; }
  var url=el.getAttribute('data-url'); if(!url) return;
  fetch(url).then(function(r){ return r.text(); }).then(function(html){
    var doc=new DOMParser().parseFromString(html,'text/html'); var fresh=doc.querySelector('[data-gvrel]');
    if(fresh && fresh.querySelector('.gvp-card')){ el.innerHTML=fresh.innerHTML; paintWish(); }
  }).catch(function(){});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gv-wishlist"] && !Shopify.designMode) return;
  try {
    
(function () {
  var KEY = 'gv_wish';
  var grid = document.querySelector('[data-gvwl-grid]');
  var empty = document.querySelector('[data-gvwl-empty]');
  var countEl = document.querySelector('[data-gv-wish-count]');
  if (!grid) return;
  var tsWidget = grid.getAttribute('data-ts-widget') || '';

  function read() { var a; try { a = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } return Array.isArray(a) ? a.filter(function (x) { return x && x.id !== undefined && x.id !== null && x.id !== ''; }) : []; }
  function write(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} document.dispatchEvent(new CustomEvent('gv:wish:change', { detail: a })); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[m]; }); }

  function render() {
    var items = read();
    if (countEl) { countEl.textContent = items.length; if (items.length) countEl.removeAttribute('hidden'); else countEl.setAttribute('hidden', ''); }
    if (!items.length) { grid.hidden = true; grid.innerHTML = ''; if (empty) empty.hidden = false; return; }
    if (empty) empty.hidden = true;
    grid.hidden = false;
    grid.innerHTML = items.map(function (p) {
      var url = esc(p.url || '#'), img = esc(p.img || ''), title = esc(p.title || 'Produkt'), price = esc(p.price || ''), id = esc(p.id), sku = esc(p.sku || ''), variant = esc(p.variant || '');
      var stars = (tsWidget && sku) ? '<etrusted-widget class="gvwl-stars" data-etrusted-widget-id="' + esc(tsWidget) + '" data-sku="' + sku + '"></etrusted-widget>' : '';
      var cta = p.multi
        ? '<a class="gvwl-cart" href="' + url + '">Auswählen</a>'
        : (variant ? '<form class="gvwl-cart-form" action="/cart/add" method="post" style="display:contents"><input type="hidden" name="id" value="' + variant + '"><button type="submit" class="gvwl-cart">In den Warenkorb</button></form>' : '<a class="gvwl-cart" href="' + url + '">Ansehen</a>');
      return '<div class="gvwl-card">' +
        '<button class="gvwl-x" data-remove="' + id + '" aria-label="Von der Merkliste entfernen">×</button>' +
        '<a class="gvwl-pic" href="' + url + '">' + (img ? '<img src="' + img + '" alt="' + title + '" loading="lazy">' : '') + '</a>' +
        '<div class="gvwl-b">' + stars +
          '<a class="gvwl-title" href="' + url + '">' + title + '</a>' +
          (price ? '<div class="gvwl-price">' + price + '</div>' : '') +
          cta +
        '</div></div>';
    }).join('');
  }

  // Entfernen aus der Merkliste. „In den Warenkorb" ist ein NATIVES Formular -> Theme-Warenkorb (/cart).
  grid.addEventListener('click', function (e) {
    var x = e.target.closest('[data-remove]');
    if (x) { var id = String(x.getAttribute('data-remove')); write(read().filter(function (p) { return String(p.id) !== id; })); render(); return; }
  });

  document.addEventListener('gv:wish:change', render);
  render();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-welten"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initHero(root){
    if(root.dataset.gvInit) return; root.dataset.gvInit = '1';
    // Einpassen: Platz über dem Hero messen (Announce/Laufband/Header) -> --gv-offset.
    // So ist der komplette Hero inkl. Buttons/Tabs beim Aufruf ohne Scrollen sichtbar.
    if(root.classList.contains('is-fit')){
      var applyOffset = function(){
        var off = Math.round(root.getBoundingClientRect().top + (window.pageYOffset || 0));
        if(off >= 0 && off <= 400) root.style.setProperty('--gv-offset', off + 'px');
      };
      // Mehrfach messen: Fonts/Leisten über dem Hero laden nach und verschieben das Layout.
      applyOffset();
      if(window.requestAnimationFrame) requestAnimationFrame(applyOffset);
      setTimeout(applyOffset, 350);
      setTimeout(applyOffset, 1200);
      window.addEventListener('load', applyOffset);
      window.addEventListener('resize', function(){ clearTimeout(root._gvFitT); root._gvFitT = setTimeout(applyOffset, 120); });
    }
    var imgs = root.querySelectorAll('.gvhero-img');
    var tabs = root.querySelectorAll('.gvhw');
    var textEl = root.querySelector('[data-role="text"]');
    var cta1 = root.querySelector('[data-role="cta1"]');
    var n = tabs.length; if(!n) return;
    var cur = 0, timer = null, picked = false;
    function setWorld(i){
      cur = i;
      imgs.forEach(function(im,k){ im.classList.toggle('is-active', k===i); });
      tabs.forEach(function(t,k){ t.classList.toggle('is-on', k===i); t.setAttribute('aria-selected', k===i ? 'true':'false'); });
      var t = tabs[i];
      if(textEl) textEl.textContent = t.getAttribute('data-text') || '';
      if(cta1){
        var lbl = t.getAttribute('data-label') || '';
        var cl  = t.getAttribute('data-cta-label') || 'entdecken';
        cta1.innerHTML = '„' + lbl + '“ ' + cl + ' <span aria-hidden="true">→</span>';
        cta1.setAttribute('href', t.getAttribute('data-cta-link') || '#');
      }
    }
    var auto = root.getAttribute('data-autorotate') === 'true';
    var iv = (parseInt(root.getAttribute('data-interval'), 10) || 8) * 1000;
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    function start(){ if(timer || picked || !auto || reduce) return; timer = setInterval(function(){ setWorld((cur + 1) % n); }, iv); }
    function pause(){ if(timer){ clearInterval(timer); timer = null; } }
    function stop(){ picked = true; pause(); }                 // permanent: nach echter Auswahl
    tabs.forEach(function(t,k){ t.addEventListener('click', function(){ stop(); setWorld(k); }); });
    var sw = root.querySelector('.gvhero-worlds');
    if(sw){ sw.addEventListener('mouseenter', pause); sw.addEventListener('mouseleave', start); } // pause nur über den Tabs
    setWorld(0);
    start();
  }
  function initAll(){ document.querySelectorAll('.gvhero').forEach(initHero); }
  if(document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();
})();
